import { useEffect, useState } from "react";

declare global {
  interface Window {
    EventManager?: any;
  }
}

export const useApoints = () => {
  const [apoints, setApoints] = useState(0);

  useEffect(() => {
    if (!window.EventManager) return;

    window.EventManager.addHandler("update:menu:apoints", (amount: number) => {
      setApoints(amount);
    });
  }, []);

  return apoints;
};
